import PageHandler from "./PageHandler";
import Pages from "Pages";

class LicenseDetailPageHandler extends PageHandler {
  constructor() {
    super("license-detail", Pages.LicenseDetailPage);
  }

  fetch() {
    this.rootStore.data.ApplicationsStore.fetch();
  }
}

export default LicenseDetailPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/LicenseDetailPageHandler.js